import * as yup from 'yup';

export const RCMVitaliciaSchema = yup.object({
  opcaoRCM: yup.bool().oneOf([true], 'Atenção, Clique em Opção RCM'),
});

export const RCMVitaliciaInitialValues = {
  opcaoRCM: false,
};
